import { getFundamentalValue } from '../../../../utils/fundamentals';
import useLocalize from '../../../../utils/hooks/useLocalize';
import DateTime from '../../../common/DateTime';

const i18nKeyPrefix = 'symbol.details.margin.information.';
const mdash = '\u2014';

const DailyMarginDate = ({ fundamentals }) => {
  const localize = useLocalize();

  const utcDateText = getFundamentalValue(
    fundamentals,
    'margin',
    'reportingDate'
  );
  if (!utcDateText) {
    return mdash;
  }

  const finalValue = getFundamentalValue(fundamentals, 'margin', 'final');
  let i18nKeySuffix = 'estimateDateFormat.noParenthesis';
  if (finalValue) {
    i18nKeySuffix = 'finalDateFormat.noParenthesis';
  }

  return (
    <DateTime
      format="MM/DD"
      value={utcDateText}
      suffix={localize(i18nKeyPrefix + i18nKeySuffix)}
    />
  );
};

export default DailyMarginDate;
